import {EventEmitter, Injectable, Output} from '@angular/core';
import {AlertController} from 'ionic-angular';

@Injectable()
export class selectRadioService {

    public alertSel: any;
    public title: string = "STATUS NF";

    constructor(public alertCtrl: AlertController) {
    }

    doSelect(list: any) {
        return new Promise((resolve, reject) => {
            if (!this.alertSel) {
                this.alertSel = this.alertCtrl.create();
                this.alertSel.setTitle(this.title);
                this.alertSel.setCssClass('c-change-empresa');

                let me = this;
                Object.keys(list).forEach(function (key, index) {
                    me.alertSel.addInput({ type: 'radio', value: list[key].optKey, checked: false, label: list[key].optVal, handler: (data: any) => { me.closeAndSave(data) } });
                }, me);

            } else {
                let dataInputs: any = this.alertSel.data.inputs;
                this.alertSel = this.alertCtrl.create({
                    enableBackdropDismiss: false
                });
                this.alertSel.setTitle(this.title);
                this.alertSel.data.inputs = dataInputs;
            }
            this.alertSel.addButton('FECHAR');
            this.alertSel.addButton({
                text: 'FILTRAR',
                handler: (data: any) => {
                    resolve(data);
                }
            });
            return this.alertSel.present();
        });
    }

    closeAndSave(opt) {
        return new Promise((resolve, reject) => {
            resolve(opt);
            let d1:any = document.querySelector("body > ion-app > ion-alert > div > div.alert-button-group > button:nth-child(2)");
            if(d1) {
                d1.click();
            }
        });
    }

    //

}


// WEBPACK FOOTER //
// ./src/providers/util/selectRadio.service.ts